// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>

const styles = theme => ({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '20px 40px',
  },
  rowContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    [theme.breakpoints.down(750)]: {
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    },
  },
  inputStyle: {
    width: 250,
    [theme.breakpoints.down(850)]: {
      width: 210,
    },
    [theme.breakpoints.down(750)]: {
      width: 400,
    },
    [theme.breakpoints.down(500)]: {
      width: 290,
    },
  },
  searchInputStyle: {
    width: 510,
    [theme.breakpoints.down(850)]: {
      width: 430,
    },
    [theme.breakpoints.down(750)]: {
      width: 400,
    },
    [theme.breakpoints.down(500)]: {
      width: 290,
    },
  },
  marginRight: {
    marginRight: 10,
    [theme.breakpoints.down(750)]: {
      marginRight: 0,
    },
  }
});

export default styles;
